import { IValidationResult } from '../../interfaces/validation.interface';
import { PatternsParser } from './PatternsParser';
import { PatternsConstraints } from './PatternsConstraints';
import { ContentValidatorHelper } from '../../ContentValidatorHelper';
import { config } from './config/config';
import EducationalArticleImage from '../../../../assets/images/validator/educationalArticle.png';
import ListingArticle from '../../../../assets/images/validator/listingArticle.png';
import { PatternsConfig } from './PatternsConfig';
import { HtmlNodesHelper } from './HtmlNodesHelper';

/**
 * @class PatternsValidator
 * @classdesc Validator for Patterns used by ContentValidator
 */
export default class PatternsValidator {
  private parser: PatternsParser;
  private tag: DefaultTags;
  private htmlNodes: NodeListOf<ChildNode>;

  constructor (htmlNodes: NodeListOf<ChildNode>, tag: DefaultTags, private articleType?: string) {
    this.htmlNodes = htmlNodes;
    this.parser = new PatternsParser(htmlNodes || []);
    this.tag = tag;
  }

  validate(): IValidationResult {
    const { minimumH2 } = new PatternsConfig(config).getGeneral();

    if (
      this.tag !== 'ar' ||
      !this.htmlNodes ||
      this.htmlNodes.length === 0 ||
      !this.articleType ||
      HtmlNodesHelper.countTags(this.htmlNodes, 'H2') < minimumH2
    ) return ContentValidatorHelper.createValidation();

    const parsedHtml = this.parser.parse();
    const currentPatternConfig = {
      ...config,
      patterns: {
        [this.articleType]: config.patterns[this.articleType],
      },
    };

    const constraints = new PatternsConstraints(parsedHtml, currentPatternConfig);
    const errorDetails = constraints.validate();

    if (errorDetails.length > 0) {
      return {
        errors: [{
          message: 'The content is not conform to the recommended patterns',
          images: [EducationalArticleImage, ListingArticle],
          details: errorDetails,
          meta: {
            validator: 'patterns',
          },
        }],
        warnings: [],
      };
    }

    return ContentValidatorHelper.createValidation();
  }
}
